<template>
    <div>
  
      <div class="container" id="chart" ref="testDiv">
        <div class="d-block d-xl-none">
          <!-- 主按鈕 mb -->
          <div class="form-group">
            <h1 class="product_title_mobile text-left">{{needs.pickedTag.name}} <span>{{needs.pickedTag.name_en}}</span> </h1>
            <div class="col-12">
              <div class="search">
                <span class="fa fa-search"></span>
                <input placeholder="搜尋" v-model="searchName" @change="searchSend()">
              </div>
            </div> 
          </div> 
        </div>
  
        <div class="d-none d-xl-block">
          <div class="row bar">
            <div class="col-12 col-md-auto">
                <h1 class="product_title text-left">{{needs.pickedTag.name}} <span>{{needs.pickedTag.name_en}}</span></h1>
            </div>
            

            <div class="col-12 col-xl-auto ml-auto search-parent">
            <div class="search">
              <span class="fa fa-search"></span>
              <input placeholder="搜尋" v-model="searchName" @change="searchSend()">
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col-sm-3 col-lg-auto mb-3 mr-0" v-for="(item) in needs.pickedTag.children" :key="item.id">
            <div v-if="item.show_type == 1">
            <select :ref="'select-' + item.id"  class="select_box text-center" 
                 style="cursor:pointer" 
                :class="{ 'select-active': pickedSubTag === item.id }"
                @click="item.showOptions = !item.showOptions" @change="updateSelection(item, $event.target.value)" >
                <option v-show="false" disabled selected>{{ item.name + '▼' }}</option>
                <!--<option value="0">all</option>-->
                <option value="2">戶外</option>
                <option value="3">室內</option>
            </select>
           
            </div>
            <!-- 如果 item 沒有子選項，則只顯示按鈕 -->
            <div v-else>
                <div class="select_box text-center" 
                style="cursor:pointer" 
                :class="{ 'select-active': pickedSubTag === item.id }"
                @click="updateOneSelection(item)">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <!-- 次按鈕 -->
        <!--
        <div class="row second-btn-mb">
          <div class="col-4 col-sm-3 col-lg-auto mb-3 mr-0 " v-for="(item) in needs.pickedTag.children" :key="item.id" style="cursor:pointer"
            @click="setSubTag(item)">
            <div class="mx-0 px-0 px-lg-3 bg-red py-1 bg-red-text" :class="{'subActive':pickedSubTag==item.id}">
              {{item.name}}
            </div>
          </div> 
          
          <div class="col-12 col-xl-auto ml-auto search-parent">
            <div class="search">
              <span class="fa fa-search"></span>
              <input placeholder="搜尋" v-model="searchName" @change="searchSend()">
            </div>
          </div> -->
  
        <!-- 內容 -->
        <!-- chart -->
        <div class="row chart-style ">
          <div class="col-12 col-xl-6 each-element align-self-stretch " v-for="(item,index) in needs.messages" :key="item.id">
            <div class="row mx-0 justify-content-center ">
              <!-- order-1 -->
              <div class="col-12 col-xl-6 mb-3 mb-xl-0 order-2 order-xl-1" style="cursor:pointer" @click="isFront=true,setImgText(index),showModal()">
                <div v-if="item.is_youtube_cover == 1">
                    <iframe width="100%" frameborder="0" :src="item.youtube_link" allowfullscreen="allowfullscreen"></iframe>
                </div>
                <div v-else>
                    <img :src="needs.messages[index]['cover_image_1x1']" alt="" class="topic-pic">
                </div>
              </div>
              <!-- order-2 -->
              <div class="col-11 col-xl-6 order-1 order-xl-2 min-180">
                <div class="row  h-25-100  text-left">
  
                  <div class="icon-bg " style="width:15px">
                    <div class="row h-100  align-items-center" >
                      <!-- <div class="col ">
                        <img src="/static/icon/icon-02@4x.png" width="25" height="30" alt="">
                      </div> -->
                    </div>
                  </div>
                  <div class="col title-bg text-left ">
                    <div class="row  h-100">
                      <div class="col h-100  msg-title clamp-1" :title="item.title" >{{needs.messages[index]['title']}}</div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-xl-block h-75">
                  <div class="  h-75 ">
                    <div class=" px-0 text-left  clamp-3 wrap">{{needs.messages[index]['description']}}</div>
                  </div>
  
  
                  <div class="row justify-content-end h-25 align-items-end ">
                    <div  v-show="item.is_ask == 1" class="col-auto px-2 py-1 btn  text-white" style="cursor:pointer;border-radius:15px;background-color:rgb(195, 13 , 35)" @click="isFront=false,setImgText(index),showModal()">
                      <!-- <img src="/static/chart/1200/3.jpg" style="max-width:100%"> -->
                      <i class="fas fa-comment-dots mr-1"></i>我要詢價
                    </div>
                  </div>
                </div>
  
              </div>
              <!-- order-3 -->
              <div class="col-12 order-3 d-block d-xl-none">
                <div class="text-left text-md-center text-xl-left clamp-3 wrap" style="min-height:150px;font-size:14px" v-if="needs.messages[index]['description']">{{needs.messages[index]['description']}}</div>
                <div class="text-right text-md-center text-xl-right ">
                  <div  v-show="item.is_ask == 1" class=" px-2 py-1 btn  text-white" style="cursor:pointer;border-radius:15px;background-color:rgb(195, 13 , 35)" @click="isFront=false,setImgText(index),showModal()">
                  <!-- <img src="/static/chart/1200/3.jpg" style="max-width:100%"> -->
                   <i class="fas fa-comment-dots mr-1" ></i>我要詢價
                </div>
                </div>
                
  
              </div>
  
            </div>
  
          </div>
  
        </div>
  
  
  
        <!-- <button type="button" @click="doScroll()" class="bg-dark">asaaaaaaaad</button> -->
        <!-- :use-router='useRouter' -->
        <b-pagination-nav size="sm" :link-gen="linkGen" :number-of-pages="needs.numberOfPages" v-model="needs.currentPage" align="center" />
  
  
        <!-- modal -->
        <b-modal ref="myModalRef" hide-header centered size="lg" title="Bootstrap-Vue" @shown="shownModal" @hidden="hiddenModal">
  
          <div class="front-page" v-show="isFront">
            <div class="row m-0 w-100">
              <div class="col-12  ">
                <h3 class="text-center ">{{needs.modalTitle}}</h3>
  
              </div>
              <!-- 圖片區 -->
              <div class="col-xl-7 py-3 order-xl-1  d-none d-xl-block">
                <img :src="needs.modalImg" alt="" style="width:100%" v-if="!framepicked">
                <iframe :src="needs.iframeurl" frameborder="0" style="width:100%;height: 300px" v-if="framepicked" allowfullscreen></iframe>
  
              </div>
              <!-- 文字區 -->
              <div class="col-12 col-xl-5 order-2 order-xl-2 py-xl-3">
  
                <p class="wrap text-left px-3">{{needs.modalText}}</p>
  
              </div>
              <!-- 輪播區 -->
              <div class="col-12 my-3 mt-xl-3  order-1 order-xl-3 ">
                <swiper :options="swiperOption" ref="mySwiper" class="px-0 px-xl-5">
                  <swiper-slide @click.native="pickFrameToTop()" style="cursor:pointer" v-if="needs.iframeurl!=='' ">
                    <iframe :src="needs.iframeurl" frameborder="0" style="width:100%;height: 97.5px;z-index:-1;pointer-events: none" class="d-none d-xl-block frameheight"></iframe>
                    <iframe :src="needs.iframeurl" frameborder="0" style="width:100%;z-index:-1" class="d-xl-none frameheight" allowfullscreen></iframe>
                  </swiper-slide>
                  <swiper-slide v-for="(item,index) in needs.modalImgList" :key="item.id" @click.native="pickImgToTop(index)" style="cursor:pointer">
                    <img :src="item" alt="">
                  </swiper-slide>
  
  
  
                  <div class="swiper-button-prev " slot="button-prev"></div>
                  <div class="swiper-button-next " slot="button-next"></div>
                </swiper>
  
              </div>
  
            </div>
          </div>
          <!-- 反面 -->
          <div class="back-page" v-show="!isFront">
            <div class="container py-4">
              <!-- 公司圖 -->
              <div id="company-img" class="mb-3">
                <div class="d-inline-block">
                  <img src="/static/chart/logo.png" alt="">
                </div>
                <div class="d-inline-block font-weight-bold pl-3" style="font-size:24px">詢價單</div>
              </div>
              <!-- 主圖+名稱 -->
              <div id="picked-item" class="mb-3">
                <div class=" font-weight-bold mb-2" style="font-size:30px">名稱: {{needs.modalTitle}}</div>
                <div class="">
                  <img :src="needs.modalImg" height="200px" width="200px">
                </div>
                
              </div>
              <!-- 聯絡區塊 -->
              <div class="send-message text-left">
                <div class="row  px-3">
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">公司名稱</div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.company">
                  </b-form-input>
  
  
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">聯絡人<span style="color:rgb(171, 41, 43)">*</span>
                  </div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.user_name">
                  </b-form-input>
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">EMAIL<span style="color:rgb(171, 41, 43)">*</span>
                  </div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.email">
                  </b-form-input>
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">聯絡電話<span style="color:rgb(171, 41, 43)">*</span>
                  </div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.phone">
                  </b-form-input>
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">傳真號碼</div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.fax">
                  </b-form-input>
                  <div class="col-6 col-xl-2 mb-1 mb-xl-3">聯絡地址</div>
                  <b-form-input type="text" placeholder="" class="col-12 col-xl-4 mb-1 mb-xl-3" v-model="form.address">
                  </b-form-input>
  
  
                </div>
  
  
  
                <div class="row px-3 ">
                  <div class="col-6  col-xl-2 ">備註
                    <span style="color:rgb(171, 41, 43)">*</span>
                  </div>
                  <b-form-textarea class="col-12 col-xl-10" v-model="form.content" placeholder="" :rows="6" :max-rows="10">
                  </b-form-textarea>
                </div>
  
              </div>
  
            </div>
  
          </div>
  
          <div slot="modal-footer" class=" w-100">
  
            <div class="row justify-content-center ">
  
              <div class="col-auto px-1 px-xl-4" v-if="!isFront">
                <b-btn size="md" class="bg-danger" @click="sendMsg">
                  送出
                </b-btn>
  
              </div>
  
              <div class="col-auto px-1 px-xl-4">
                <b-btn size="md" v-show="isFront" @click="isFront=!isFront">
                  聯絡我們
                </b-btn>
                <b-btn size="md" v-show="!isFront" @click="isFront=!isFront">
                  回上一頁
                </b-btn>
  
              </div>
              <div class="col-auto px-1 px-xl-4 ">
                <b-btn size="md" class="float-right bg-close" @click="hideModal">
                  關閉
                </b-btn>
              </div>
  
  
  
  
            </div>
  
  
  
  
  
          </div>
  
  
  
        </b-modal>
  
  
      </div>
  
  
    </div>
  </template>
  
  
  
  
  <script>
  import Vue from "vue";
  import axios from "axios";
  import VueAxios from "vue-axios";
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  
  Vue.use(VueAxios, axios);
  
  export default {
    beforeRouteUpdate (to, from, next) {
      if(to.query.tag!==from.query.tag  && this.needs.currentPage!=1){
        this.needs.currentPage=1;
       
        next({ path:to.path ,query: { tag: to.query.tag,page:this.needs.currentPage } })
        
      }
      else{
          next();
      }
      
    },
    data() {
      return {
        // useRouter: true, //要開才會從現在位置算 url
        a: [
          {
            xs: "/static/privacy/768/1.jpg",
            sm: "/static/privacy/768/1.jpg",
            md: "/static/privacy/768/1.jpg",
            lg: "/static/privacy/768/1.jpg",
            xl: "/static/privacy/1200/1.jpg"
          }
        ],
        needs: {
          currentPage: 0,
          numberOfPages: 1000,
          dataPerPage: 8,
          messages: [],
          pickedTag:{},
          urlPickedTag:0,
          allTag: [],
          modalImg: "",
          modalImgList: [],
          modalTitle:'',
          modalText:'',
          iframeurl:'',
          
        },
        pickedSubTag:0,
        showPlace: true,
        pickedPlace: 0,
        places: [
          { id: 0, name: '全部' },
          { id: 2, name: '室外' },
          { id: 3, name: '室內' }       
        ],
        dataTagId:0,
        searchName:'',
        isFront:true,
        framepicked:false,
        swiperOption: {
            lazy: false,
            autoHeight: false,
            slidesPerView: 5,
            spaceBetween: 30,
            loop: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            breakpoints: {
              1199: {
                slidesPerView: 1,
                spaceBetween: 80
              }
            }
            
          },
           form: {
          user_name: '',
          email: '',
          phone: '',
          title: '',
          content: '',
          company: '',
          fax: '',
          address: '',
          id:''
        },
        mainBtnShow: false,
       
      };
    },
    watch:{
      '$route' :function(){
         this.needs.urlPickedTag=parseInt(this.getParameterByName('tag'));
         this.needs.allTag.forEach(element => {
          if(element.id==this.needs.urlPickedTag){
            this.needs.pickedTag=element;
          }
         });
      },
      'needs.currentPage':function(){
        // console.log('change'+this.needs.currentPage);
        // console.log('watch')
        // if(this.searchName!=''){
        //   this.pickedPlace = 0;
        //   this.getData(this.searchName,'0');
        // }
        // else{
        //   this.pickedPlace = 0;
        //   this.getData();
        // }
        this.getDataV2();
        this.doScroll()
        // // this.linkGen(this.currentPage);
        
      },
      'needs.pickedTag':function(){
        // console.log('切換分類');
        // if(this.pickedSubTag!=0){
        //   this.pickedSubTag=0
        // }
      //   //tag改變 次tag修正為0 不去要資料 不要show顏色
      //   this.dataTagId=this.needs.pickedTag.id;
        this.searchName = '';
        this.pickedSubTag = this.needs.pickedTag.id;
        this.pickedPlace = 0;
        this.getDataV2()
        
      },
      'pickedSubTag':function(){
        // this.needs.currentPage=1;
        // console.log('換分類');
        // if(this.pickedSubTag!=0){
        //   //次tag等於零 不去要資料
        //   this.dataTagId=this.pickedSubTag; 
        // }
        //  this.searchName='';
      },
      // 'dataTagId':function(){
        // this.getDatav2()
      // },
      
  
    },
    methods: {
      toggleMainBtn(){
            this.mainBtnShow=!this.mainBtnShow;
      },
      togglePlace(placeId) {  
        this.pickedPlace = placeId;
        this.getData()
      },
      changeRoute(){
        this.$router.push({path:'/charttest' + '?tag='+this.needs.pickedTag.id +'&page='+this.needs.currentPage });
      },
      // changeRoute(event) {
      //   const path=event.target.value;
      //   // console.log(typeof(path))
    
      //   // alert(path)
      //   switch (path){
      //     case '字幕機':
      //         this.$router.push({path:'/charttest' + '?tag=2&page=1' });
      //         break;
      //     case '電視牆':
      //         this.$router.push({path:'/charttest' + '?tag=3&page=1' });
      //         break;
      //     case 'LED省電招牌':
      //         this.$router.push({path:'/charttest' + '?tag=4&page=1' });
      //         break;
      //     case '亮化工程':
      //         this.$router.push({path:'/charttest' + '?tag=5&page=1' });
      //         break;
      //     case 'LED應用產品':
      //         this.$router.push({path:'/charttest' + '?tag=6&page=1' });
      //         break;
      //     case '舞台車':
      //         this.$router.push({path:'/charttest' + '?tag=39&page=1' });
      //         break;
      //   } 
      //         // this.$router.push({path:'/charttest' + '?tag=5&page=1' })
      //         // this.$router.push({name:'charttest', query: {tag: 3, page: needs.currentPage  }});
      //             // :to="{name:'charttest', query: {tag: item.id, page: needs.currentPage  }}"
      // },
      sendMsg(){
        let vm = this;
        if (vm.submit) {
          Vue.$toast.open({
                message: '表單正在傳送中，請稍等....',
                type: 'warning'
          });
          return;
        }
        this.sumbit = true;
        // console.log(vm.form)
        axios({
          method: "post",
          url: "https://iled.com.tw/bridging/api/v1/contact",
          params: vm.form
        })
          .then(function(response) {
            if(response.data.status==true){
              // alert(response.data.message);
              Vue.$toast.open({
                message: response.data.message,
                type: 'success'
              });
              // add
              vm.hideModal();
            }
            else{
              // alert();
              Vue.$toast.open({
                message: response.data.error[0]['message'],
               type: 'error'
             });
              //等等
            }
            // console.log(response)
          
          
  
          }).finally(() => {
            this.submit = false;
    
           });
      }
      ,
      resetForm(){
        this.form.user_name = '';
        this.form.email = '';
        this.form.phone = '';
        this.form.title = '';
        this.form.content = '';
        this.form.company = '';
        this.form.fax = '';
        this.form.address = '';
        this.form.id = '';
      },
      updateSwiper(){
        let vm =this;
        vm.$refs.mySwiper.update();
      }
      ,
      pickFrameToTop(link){
        
        this.framepicked=true;
      }
      ,
       pickImgToTop(index){
        this.needs.modalImg=this.needs.modalImgList[index];
        this.framepicked=false;
      },
      setImgText(index){
        this.needs.modalImgList=[];
        this.needs.messages[index]['images_1x1'].forEach(element => {
          this.needs.modalImgList.push('https://iled.com.tw/bridging'+element);
        });
        this.needs.modalImg=this.needs.modalImgList[0];
        this.needs.modalTitle='';
        this.needs.modalTitle=this.needs.messages[index]['title'];
        this.needs.modalId='';
        this.needs.modalId=this.needs.messages[index]['id'];
        // console.log('id');
        // console.log(this.needs.modalId);
        this.form.id=this.needs.modalId;
        // console.log(this.form.id);
        this.needs.modalText='';
        this.needs.modalText=this.needs.messages[index]['description'];
        this.needs.iframeurl='';
        
        this.needs.iframeurl=this.needs.messages[index]['youtube_link'];
        
      },
      showModal () {
       let vm=this
        vm.$refs.myModalRef.show();
        if(vm.needs.iframeurl!=='')
          vm.framepicked=true;
        else
          vm.framepicked=false;
       
      },
      shownModal(){
         let vm=this
        vm.$refs.mySwiper.update();
      },
      
      hideModal () {
        this.$refs.myModalRef.hide();
        
      },
      hiddenModal(){
        this.isFront=true;
        this.framepicked=true;
        this.resetForm();
        this.swiper.slideTo(0, 1000, false)
      },
      doScroll(){
        // console.log('do scroll')
        document.documentElement.scrollTop = 50
      
      },
      searchSend(){
       this.pickedSubTag= 0;
       this.pickedPlace = 0;
       this.showPlace = true;
       this.needs.currentPage = 1;
       this.getDataV2();
       this.changeRoute();
       
      },
      setActiveItem(item) {
        this.pickedSubTag=item.id;
      },
      updateOneSelection(item) {
        // console.log(place);
        this.pickedPlace = 0;
        this.needs.currentPage = 1;
        this.pickedSubTag = item.id;
        // this.linkGen(0);
        this.changeRoute();
        this.getDataV2();
      },
      updateSelection(item, place) {
        // console.log(place);
        this.pickedPlace = parseInt(place);
        this.needs.currentPage = 1;
        this.pickedSubTag = item.id;
        this.changeRoute();
        this.$refs['select-' + item.id][0].value = item.name + '▼';
        this.getDataV2();
      },
      //即將拿掉
      // setSubTag(item){
      //   // console.log(item);
      //   if(item.show_type == '1'){
      //     this.showPlace = true;
      //   }else{
      //     this.showPlace = false;
      //   }
      //   this.pickedSubTag=item.id;
      // },
      // setSubTagZero(item){
      //   //在tag沒被change的情況 觸發
      //   //放在tag按鈕上 讓子按鈕要取消時可以用 髒方法
      //   this.pickedSubTag=0;
      //   this.pickedPlace = 0;
      //   this.showPlace = true;
      //   this.dataTagId=item.id;
      //   this.getData();//這邊雖然 watch dataTag會去getdata，但是重複按的時候也要撈一次
      //   //所以 某些時候會get 2 次  髒方法
      // },
  
      // helpme(item){
      //   // alert(this.needs.currentPage);
      //     // this.needs.currentPage=1;
      //     this.needs.pickedTag=item
      //     this.setSubTagZero(item)
      // },
      pusha() {
        let vm = this;
        vm.$emit("pusha", vm.a);
      },
      // pageGen(pageNum){
      //     return 'A'
      // },
      // http://localhost:8000/#/charttest?tag=2&page=1
    
      linkGen(pageNum) {
        //純粹控制/page
        // return "" + pageNum;
      return  {
        path: '/charttest?tag='+this.needs.pickedTag.id +'&page='+pageNum
      }
        // return '#charttest?tag='+this.needs.pickedTag.id +'&page='+pageNum
        // return {
        //   name:'charttest',
        //   query: {tag: this.needs.pickedTag.id ,page: pageNum }
          
        // }
        
      },
      getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
      }
      ,
      getUrl:function(){
       
  
        this.needs.currentPage = parseInt(this.getParameterByName('page'));
        this.needs.urlPickedTag=parseInt(this.getParameterByName('tag'));
        
        //now
        // this.needs.pickedTag.id=parseInt(this.getParameterByName('tag'));
        // console.log('tag='+this.getParameterByName('tag'));//string 從string改num
        
        // console.log('page='+this.getParameterByName('page'));// page 從string改num
      },
      getData:function(searchName,categories,offset) {
        return;
        let vm = this;
        axios({
          method: "post",
          url: "https://iled.com.tw/bridging/api/v1/products",
          params: {
            limit: vm.needs.dataPerPage,
            offset: offset||vm.needs.dataPerPage * (vm.needs.currentPage - 1),
            cover_image: 1,
            categories: categories||vm.dataTagId,
            type_id:  vm.pickedPlace,
            search: searchName
          }
        })
          .then(function(response) {
            vm.needs.messages = [];
            if(response.data.data.length>0){
                response.data.data.forEach(element => {
              element['cover_image_1x1']='https://iled.com.tw/bridging'+element['cover_image_1x1'];
  
              vm.needs.messages.push(element);
            });
            }
            // console.log(vm.needs.messages)
             let dataCount = response.data.total;
            //  console.log('dataCount'+dataCount);
             let rest=(dataCount % vm.needs.dataPerPage);
            vm.needs.numberOfPages = parseInt(dataCount / vm.needs.dataPerPage) ;
            if(vm.needs.numberOfPages==0 || rest!=0) {vm.needs.numberOfPages=vm.needs.numberOfPages+1}
            // console.log('numberOfPages'+vm.needs.numberOfPages);
            // console.log(response)
            
            
  
          })
      },
      getDataV2:function() {
        let vm = this;
        axios({
          method: "post",
          url: "https://iled.com.tw/bridging/api/v1/products",
          params: {
            limit: this.needs.dataPerPage,
            offset: this.needs.dataPerPage * (this.needs.currentPage - 1),
            cover_image: 1,
            categories: this.pickedSubTag,
            type_id:  this.pickedPlace,
            search: this.searchName
          }
        })
          .then(function(response) {
            vm.needs.messages = [];
            if(response.data.data.length>0){
                  response.data.data.forEach(element => {
                    element['cover_image_1x1']='https://iled.com.tw/bridging'+element['cover_image_1x1'];
                  vm.needs.messages.push(element);
              });
            }
            // console.log(vm.needs.messages)
             let dataCount = response.data.total;
             let rest=(dataCount % vm.needs.dataPerPage);
            vm.needs.numberOfPages = parseInt(dataCount / vm.needs.dataPerPage) ;
            if(vm.needs.numberOfPages==0 || rest!=0) {vm.needs.numberOfPages=vm.needs.numberOfPages+1}
          })
      },
      getAllTag:function() {
        let vm = this;
        axios({
          method: "post",
          url: "https://iled.com.tw/bridging/api/v1/categories" 
        })
          .then(function(response) {
            // console.log(response);
            vm.needs.allTag = [];
            if(response.data.data.length>0){
              response.data.data.forEach(element => {   
              element.id=parseInt(element.id); 
              // console.log(element.id);  
              vm.needs.allTag.push(element);
            });
            }
            // console.log('allTag');
            // console.log(vm.needs.allTag);
            
            //set pickedTag
            vm.needs.allTag.forEach(element => {
              if(element.id==vm.needs.urlPickedTag){


                vm.needs.pickedTag= element;
              }
            });
          })
      },
      init() {
        //get tag first
        console.log('init');
        this.getUrl(); //頁數跟tag
        this.getAllTag(); 
        // this.getDataV2()
        //init的時候不用getDataV2 因為 watch會自己去抓
        
        
      }
    },
    created: function() {

      this.pusha();
      this.init();
      
     
    },  
    mounted: function() {
    
      
    },
    components: {
      swiper,
      swiperSlide
    },
    computed:{
      swiper() {
          return this.$refs.mySwiper.swiper
        }
    }
   
  };
  </script>
  
  <style lang="sass" scoped>
  
  @import "~bootstrap/scss/bootstrap"
  
  @import url("https://use.fontawesome.com/releases/v5.0.12/css/solid.css")
  @import url("https://use.fontawesome.com/releases/v5.0.12/css/fontawesome.css")
  
  .link
    color: black
    font-weight: bold
    @include media-breakpoint-up(xl) 
      font-size: 24px
    @include media-breakpoint-up(xs) 
      font-size: 14px
    // &:hover
    //   color: rgb(195, 13 , 35)
  
  .active
    color: rgb(195, 13 , 35) !important
  .bg-red 
    background-color: white !important
    color: rgb(185, 40 , 45) !important
    border: 1px solid rgb(195, 13 , 35) !important
    &:hover
      background-color: rgb(195, 13 , 35) !important
      color: white !important
  .bg-red.subActive
    background-color: rgb(195, 13 , 35) !important
    color: white !important
  .search-parent
    @include media-breakpoint-up(xs)
      display: flex;
      padding-right: 5px
      align-items: center;
    @include media-breakpoint-up(xl)
      display: flex;
      padding-right: 15px
      align-items: center;
  .search
    position: relative
    color: #aaa
    font-size: 16px
    input
      @include media-breakpoint-up(xl)
        width: 175px
      @include media-breakpoint-up(xs)
        width: 100%
      height: 40px
      background: #fcfcfc
      border: 1px solid rgb(195, 13 , 35)
      border-radius: 5px
      box-shadow: 0 0 3px #ccc, 0 10px 15px #ebebeb inset
      text-indent: 32px
    .fa-search
      position: absolute
      top: 10px
      left: 10px
  
  .topic-pic
    @include media-breakpoint-up(sm) 
      width: 255px
      height: 191.25px
    @include media-breakpoint-up(xs)
      width: 100%
      height: 100%
  .chart-style
    @include media-breakpoint-up(xl)
      margin-top: 35px
      margin-bottom: 90px
    @include media-breakpoint-up(xs)
      margin-top: 53px
      margin-bottom: 110px
  .each-element
    margin-bottom: 70px
    padding: 0 20px
  .each-element:nth-last-child(1)
    margin-bottom: 0
  .clamp-3
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 3
    /*! autoprefixer: off */
    -webkit-box-orient: vertical
    /* autoprefixer: on */
  .clamp-1
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 1
    /*! autoprefixer: off */
    -webkit-box-orient: vertical
    /* autoprefixer: on */
  .wrap
    white-space: pre-wrap  
  .item-title
    font-weight: bold
    font-size: 23px
    color: black
  .sliderimg 
    max-height: 100%
  
  .bg-close
    background-color: rgb(200, 85, 30)
    &:hover
      background-color: rgb(175, 70, 20)
  
  #chart
    @include media-breakpoint-up(xl)
      padding-top: 68px
      padding-bottom:  22px
    @include media-breakpoint-up(xs)
      padding-top: 46px
      padding-bottom:  114px  
  .main-btn-mr
    @include media-breakpoint-up(xs)
      margin-right: 0px
    @include media-breakpoint-up(xl)
      margin-right: 60px
  .main-btn-mb
    margin-bottom: 30px
  .title-bg
    background-color: rgb(51, 58, 64)
    color: white
    font-size: 21px
    font-weight: bold
  .icon-bg
    background-color: rgb(195, 13 , 35)
  .bg-red-text
    @include media-breakpoint-up(xl)
      font-size: 18px
      font-weight: bold
    @include media-breakpoint-up(xs)
      font-size: 14px
      font-weight: bold
  .min-180
    @include media-breakpoint-up(xl)
      min-height: 191px
      margin-bottom: 0
    @include media-breakpoint-up(xs)
      margin-bottom: 12px
      height: 45px
  .h-25-100
    @include media-breakpoint-up(xl)
      height: 20%
    @include media-breakpoint-up(xs)
      height: 100%
  .frameheight
    @include media-breakpoint-up(xs)
      height: 268px
    @include media-breakpoint-up(sm)
      height: 428px
    @include media-breakpoint-up(xl)
      height: 600px
  .msg-title
    @include media-breakpoint-up(xl)
      font-size: 24px
    @include media-breakpoint-up(xs)
      font-size: 28px
  .bar
    @include media-breakpoint-up(xl)
      margin-bottom: 50px
    @include media-breakpoint-up(xl)
      margin-bottom: 16px
  .bg-n-red
    @include media-breakpoint-up(xs)
      font-size: 14px
    @include media-breakpoint-up(xl)
      font-size: 25px
    background-color: rgb(182, 40 ,44)
    color: white
    text-align: center
    padding-top: 7px
    padding-bottom: 7px
  .bg-n-gray
    @include media-breakpoint-up(xs)
      font-size: 14px
    @include media-breakpoint-up(xl)
      font-size: 25px
    background-color: rgb(51, 58, 64)
    min-width: 330px
    color: white
    padding-left: 13px
    padding-top: 7px
    padding-bottom: 7px 
  .fade-enter-active, .fade-leave-active 
    transition: opacity .5s
  .fade-enter, .fade-leave-to
    opacity: 0
  .swiper-button-prev
    background-image: url('/static/icon/icon-07@4x.png')
    background-size: contain
    width: 50px
    left: -2px
  .swiper-button-next
    background-image: url('/static/icon/icon-08@4x.png')
    background-size: contain
    width: 50px
    right: -2px
  /*梯形按鈕置中*/
  .bg-place
    cursor: pointer
    margin-right: 2px
    background: white
    border: 1px solid #b9282d
    color: #b9282d
    display: inline-block
    -webkit-transform: skew(-20deg)
    transform: skew(-20deg)
    padding: 3px
    font-weight: bold
  .bg-place-active
    background: #b9282d
    color: white
  .bg-place-nav 
    margin-top: 10px
  .select_box
    appearance: none
    border: 1px solid black
    font-size: 18px
    color: black
    background-color: white
    border-radius: 12px
    padding-left: 4px
    padding-right: 4px
    cursor:pointer
    position: relative 
    option     
      cursor:pointer
      background-color: white
      color: black
  .select-active
    background-color: #333a40 !important
    color: white
  
  option
    &:checked
      background-color: #333a40 !important
      color: white
    &:hover
      background-color: #c30d23 !important
      color: white  
  .product_title_mobile
    font-weight: bolder
    font-size: 26px
    span 
        font-size: 14px
        font-weight: normal
        text-transform: uppercase
  .product_title
    font-weight: bolder
    span 
        font-size: 16px
        font-weight: normal
        text-transform: uppercase

</style>
  
  


// WEBPACK FOOTER //
// src/components/Products.vue